export default {
  form: {
    address: {
      label: 'Osoite',
      placeholder: 'Osoite',
    },
    zip_code: {
      label: 'Postinumero',
      placeholder: 'Postinumero',
    },
    city: {
      label: 'Kaupunki',
      placeholder: 'Kaupunki',
    },
    start_time: {
      label: 'Alkamisaika',
      placeholder: 'esim. 11:00',
    },
    name: {
      label: 'Sijainnin nimi (valinnainen)',
      placeholder: 'esim. Fernsehturmin vieressä',
      tooltip: 'Sijainnin nimen antaminen voi auttaa asiakkaita tunnistamaan paikan, esim. ”Fernsehturmin vieressä”',
    },
    note: {
      label: 'Huomautus',
      placeholder: 'Kirjoita huomautus',
    },
  },
  buttons: {
    add_location: 'Lisää sijainti',
  },
};
